import { ConvertirDatos } from "app/mocks/campos-filter.mock";
import * as moment from "moment";

export const tableReportesTemplate = async (
  turnos: any[],
  campos: string[]
): Promise<any> => {
  let info = {};

  const arrayTurnos = turnos.map((turno) => {
    let datos = {};

    // Validación para evitar error si shiftClass es null o undefined
    const shiftClassName = turno["shiftClass"]
      ? turno["shiftClass"]["name"]
      : null;

    if (
      shiftClassName !== "reenturne carretera" &&
      shiftClassName !== "reenturne urbanos"
    ) {
      if (shiftClassName && !info[shiftClassName]) info[shiftClassName] = {};
      if (shiftClassName) {
        info[shiftClassName]["price"] =
          (info[shiftClassName]["price"] || 0) + turno["price"];
        info[shiftClassName]["count"] =
          (info[shiftClassName]["count"] || 0) + 1;
      }
    } else {
      if (!info["reenturnados"]) info["reenturnados"] = {};
      info["reenturnados"]["price"] =
        (info["reenturnados"]["price"] || 0) + turno["price"];
      info["reenturnados"]["count"] = (info["reenturnados"]["count"] || 0) + 1;
    }

    // Conteo de turnos con precio 0 como "libres"
    if (turno["price"] === 0 || turno["price"] === "0") {
      if (!info["libres"]) info["libres"] = { count: 0, price: 0 };
      info["libres"]["count"] = (info["libres"]["count"] || 0) + 1;
    }

    campos.map((campo) => {
      switch (campo) {
        case "INGRESO":
          datos[campo] = moment(turno[ConvertirDatos[campo]]).format(
            "HH:mm:ss"
          );
          break;
        case "DEVOLUCION":
          datos[campo] = moment(turno[ConvertirDatos[campo]])
            .add(1, "days")
            .format("DD/MM/YYYY");
          break;
        case "PLACA":
          datos[campo] = turno.driver[ConvertirDatos[campo]];
          break;
        case "CONDUCTOR O EMPRESA":
          datos[campo] =
            (turno.driver[ConvertirDatos[campo]] || "") +
            (` - ${turno.client && turno.client[ConvertirDatos[campo]]}` || "");
          break;
        case "CC O NIT":
          datos[campo] =
            (turno.driver[ConvertirDatos[campo]] || "") +
            (` - ${turno.client && turno.client["nit"]}` || "");
          break;
        case "LINEA":
          datos[campo] = turno.transLine
            ? turno.transLine[ConvertirDatos[campo]]
            : "";
          break;
        case "PATIO":
          datos[campo] = turno.containerYard
            ? turno.containerYard[ConvertirDatos[campo]]
            : "";
          break;
        case "CONTENEDORES":
          datos["CONTENEDOR I"] = turno.containers[0]
            ? turno.containers[0][ConvertirDatos[campo]]
            : "";
          datos["CONTENEDOR II"] = turno.containers[1]
            ? turno.containers[1][ConvertirDatos[campo]]
            : "";
          break;
        case "TIPO/TAMAÑO":
          datos["TIPO/TAMAÑO I"] =
            turno.containers[0] && turno.containers[0].containerType
              ? turno.containers[0].containerType[ConvertirDatos[campo]]
              : "";
          datos["TIPO/TAMAÑO II"] =
            turno.containers[1] && turno.containers[1].containerType
              ? turno.containers[1].containerType[ConvertirDatos[campo]]
              : "";
          break;
        default:
          datos[campo] = turno[ConvertirDatos[campo]];
          break;
      }
    });
    return datos;
  });
  // console.timeEnd('hola')

  return { arrayTurnos, info };
};
